module.exports = __webpack_public_path__ + "img/logo-footer.ac5eb0ce.png";